import { createReducer } from '../../redux/helpers/redux-helpers'
import * as act from './component-actions'

const componentReducer = createReducer<any>(
  {
    [act.SET_DATA]: (state, data) => ({
      ...state,
      ...data,
    }),
  },
  {},
)

export default componentReducer
